import {
  CLIENT_LOAD_REQUEST,
  CLIENT_LOAD_SUCCESS,
  CLIENT_LOAD_FAILURE
} from '../types/client-types';

const initialState = {
  loading: false,
  success: false,
  error: null,
  client: null
};

function client(state = initialState, action: any = null) {
  switch (action.type) {
    case CLIENT_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case CLIENT_LOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        success: false
      };

    case CLIENT_LOAD_SUCCESS:
      return {
        ...state,
        client: action.payload,
        loading: false,
        success: true,
        error: null
      };

    default:
      return state;
  }
}

export default client;
